// extracted by mini-css-extract-plugin
export default {"mainContainer":"PrivateFreeLayout_mainContainer__un17Q"};